export default function Programs() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="programs" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <span className="text-sm font-semibold text-[#0D9488] uppercase tracking-wide whitespace-nowrap">
            CONSULTATION OPTIONS
          </span>
        </div>

        <div className="grid md:grid-cols-5 gap-8">
          <div className="md:col-span-2 bg-[#1E3A8A] rounded-3xl p-10 flex flex-col justify-between hover:scale-105 transition-all duration-300 cursor-pointer" onClick={() => scrollToSection('booking')}>
            <div>
              <div className="w-16 h-16 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center mb-8">
                <span className="text-3xl font-bold text-white">1:1</span>
              </div>
              <h3 className="text-4xl font-bold text-white mb-6 leading-tight">
                Personalized
                <br />
                Consultation
              </h3>
              <p className="text-white/80 text-base leading-relaxed mb-8">
                Work directly with our digitization experts to develop a custom preservation plan tailored to your specific archival needs and budget requirements.
              </p>
            </div>
            <div className="flex items-center text-[#D97706] font-semibold group cursor-pointer">
              <span className="whitespace-nowrap">Schedule Your Session</span>
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
            </div>
          </div>

          <div className="md:col-span-3 flex flex-col">
            <div className="mb-8">
              <h3 className="text-4xl font-bold text-[#1E3A8A] mb-4 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                Group Workshop Programs
              </h3>
              <p className="text-gray-600 text-base leading-relaxed max-w-xl">
                Join our comprehensive group training sessions to learn best practices in digitization, preservation techniques, and digital asset management for your organization.
              </p>
            </div>

            <div className="relative rounded-3xl overflow-hidden flex-1 min-h-[320px] hover:scale-105 transition-all duration-300 cursor-pointer" onClick={() => scrollToSection('booking')}>
              <img 
                src="https://public.readdy.ai/ai/img_res/2e54afe114e4c4be22698fe4f6a58560.jpg" 
                alt="Group workshop" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute top-6 left-6 bg-white/20 backdrop-blur-md rounded-xl px-5 py-3 flex items-center gap-3">
                <div className="w-10 h-10 bg-[#D97706] rounded-full flex items-center justify-center">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <span className="text-white font-semibold text-base whitespace-nowrap">GROUP SESSIONS</span>
              </div>
              <div className="absolute bottom-6 right-6 bg-white px-6 py-3 rounded-full font-semibold text-[#1E3A8A] hover:bg-[#D97706] hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="bg-[#FAFAF8] rounded-2xl p-8 hover:shadow-lg transition-all">
            <div className="w-14 h-14 bg-[#D97706]/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-customer-service-2-line text-3xl text-[#D97706]"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1E3A8A] mb-3">Expert Guidance</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Receive personalized recommendations from certified archival specialists with decades of combined experience in legacy media preservation.
            </p>
          </div>

          <div className="bg-[#FAFAF8] rounded-2xl p-8 hover:shadow-lg transition-all">
            <div className="w-14 h-14 bg-[#D97706]/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-3xl text-[#D97706]"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1E3A8A] mb-3">Quality Assurance</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Every project undergoes rigorous quality control processes to ensure optimal digital output that exceeds industry standards and client expectations.
            </p>
          </div>

          <div className="bg-[#FAFAF8] rounded-2xl p-8 hover:shadow-lg transition-all">
            <div className="w-14 h-14 bg-[#D97706]/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-time-line text-3xl text-[#D97706]"></i>
            </div>
            <h4 className="text-xl font-bold text-[#1E3A8A] mb-3">Flexible Scheduling</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Book consultations at times that work for you, with options for virtual meetings, on-site visits, and extended project support.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
